import React, { useState, useEffect } from 'react';
import { sessionTimeoutManager } from '../utils/sessionTimeoutManager';
import './SessionTimeoutModal.css';

const SessionTimeoutModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Define the event handler
    const handleSessionTimeout = () => {
      console.log('SessionTimeoutModal: SESSION_TIMEOUT event received');
      setIsOpen(true);
    };

    // Register event listener on mount
    sessionTimeoutManager.onSessionTimeout(handleSessionTimeout);

    // Cleanup on unmount
    return () => {
      sessionTimeoutManager.offSessionTimeout(handleSessionTimeout);
    };
  }, []);

  const handleRelogin = () => {
    console.log('SessionTimeoutModal: User clicked Login Again');
    setIsOpen(false);
    sessionTimeoutManager.handleRelogin('/');
  };

  const handleClose = () => {
    console.log('SessionTimeoutModal: User closed modal, will redirect in 3s');
    setIsOpen(false);
    // Still clear session and redirect even if user closes modal
    setTimeout(() => {
      sessionTimeoutManager.handleRelogin('/');
    }, 3000);
  };

  if (!isOpen) return null;

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-modal">
        <div className="modal-header">
          <h2>Session Timeout</h2>
        </div>
        
        <div className="modal-body">
          <div className="warning-icon">⚠️</div>
          <p>Your session has expired due to inactivity or invalid token.</p>
          <p>For security reasons, please login again to continue using the application.</p>
        </div>

        <div className="modal-footer">
          <button 
            className="btn btn-primary" 
            onClick={handleRelogin}
          >
            Login Again
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={handleClose}
          >
            Close
          </button>
        </div>

        <div className="modal-timer">
          <small>You will be redirected automatically in 3 seconds...</small>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
